var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentedBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 171,
    viewBox: "0 0 419 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    clipPath: "url(#clip0_14385_33097)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 852.537,
    height: 606.248,
    transform: "translate(-278.836 -216.137)",
    fill: "#5D852A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5117,
    y: 79.7422,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-90 -15.5117 79.7422)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.1782,
    y: 79.4086,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-90 -15.1782 79.4086)",
    stroke: "url(#paint0_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.8594,
    y: -49.0039,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.1929,
    y: -48.6704,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint1_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.57,
    y: 143.113,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-180 116.57 143.113)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.237,
    y: 142.78,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-180 116.237 142.78)",
    stroke: "url(#paint2_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.234,
    y: 13.0312,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.568,
    y: 13.3648,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint3_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.8438,
    y: 142.449,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5102,
    y: 142.783,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint4_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.652,
    y: 13.0312,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-180 248.652 13.0312)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.319,
    y: 12.6977,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-180 248.319 12.6977)",
    stroke: "url(#paint5_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.941,
    y: 143.113,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-90 181.941 143.113)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.275,
    y: 142.78,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-90 182.275 142.78)",
    stroke: "url(#paint6_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.316,
    y: 14.3672,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.65,
    y: 14.7007,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint7_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.023,
    y: 206.484,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-180 314.023 206.484)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.69,
    y: 206.151,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-180 313.69 206.151)",
    stroke: "url(#paint8_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.691,
    y: 76.4062,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.025,
    y: 76.7398,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint9_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.398,
    y: 143.117,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.732,
    y: 143.451,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint10_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.238,
    y: 143.117,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.572,
    y: 143.451,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    stroke: "url(#paint11_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.027,
    y: 12.3672,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-90 314.027 12.3672)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.361,
    y: 12.0336,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-90 314.361 12.0336)",
    stroke: "url(#paint12_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_14385_33097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.109,
    y: 75.7383,
    width: 66.7076,
    height: 66.7076,
    rx: 6.67076,
    transform: "rotate(-180 446.109 75.7383)",
    fill: "#F9F9F9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.776,
    y: 75.4047,
    width: 66.0405,
    height: 66.0405,
    rx: 6.33722,
    transform: "rotate(-180 445.776 75.4047)",
    stroke: "url(#paint13_linear_14385_33097)",
    strokeOpacity: 0.5,
    strokeWidth: 0.667076
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14385_33097",
    x: -48.8655,
    y: -20.3186,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14385_33097",
    x: 16.5056,
    y: -82.3577,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_14385_33097",
    x: 16.5085,
    y: 43.0525,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_14385_33097",
    x: 81.8806,
    y: -20.3225,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_14385_33097",
    x: -50.1975,
    y: 109.095,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_14385_33097",
    x: 148.591,
    y: -87.0296,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_14385_33097",
    x: 148.588,
    y: 43.0525,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_14385_33097",
    x: 213.963,
    y: -18.9866,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_14385_33097",
    x: 213.962,
    y: 106.424,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_14385_33097",
    x: 279.338,
    y: 43.0525,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_14385_33097",
    x: 346.045,
    y: 109.763,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_14385_33097",
    x: 81.8845,
    y: 109.763,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_14385_33097",
    x: 280.674,
    y: -87.6936,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_14385_33097",
    x: 346.048,
    y: -24.3225,
    width: 133.416,
    height: 133.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.6769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14385_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14385_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14385_33097",
    x1: 17.8421,
    y1: 79.7422,
    x2: 17.8421,
    y2: 146.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14385_33097",
    x1: 83.2132,
    y1: -49.0039,
    x2: 83.2132,
    y2: 17.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14385_33097",
    x1: 149.924,
    y1: 143.113,
    x2: 149.924,
    y2: 209.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14385_33097",
    x1: 148.588,
    y1: 13.0312,
    x2: 148.588,
    y2: 79.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14385_33097",
    x1: 16.5101,
    y1: 142.449,
    x2: 16.5101,
    y2: 209.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14385_33097",
    x1: 282.006,
    y1: 13.0312,
    x2: 282.006,
    y2: 79.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14385_33097",
    x1: 215.295,
    y1: 143.113,
    x2: 215.295,
    y2: 209.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14385_33097",
    x1: 280.67,
    y1: 14.3672,
    x2: 280.67,
    y2: 81.0748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14385_33097",
    x1: 347.377,
    y1: 206.484,
    x2: 347.377,
    y2: 273.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14385_33097",
    x1: 346.045,
    y1: 76.4062,
    x2: 346.045,
    y2: 143.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14385_33097",
    x1: 412.752,
    y1: 143.117,
    x2: 412.752,
    y2: 209.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14385_33097",
    x1: 148.592,
    y1: 143.117,
    x2: 148.592,
    y2: 209.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14385_33097",
    x1: 347.381,
    y1: 12.3672,
    x2: 347.381,
    y2: 79.0748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14385_33097",
    x1: 479.463,
    y1: 75.7383,
    x2: 479.463,
    y2: 142.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14385_33097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 852.537,
    height: 606.248,
    fill: "white",
    transform: "translate(-278.836 -216.137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentedBanner);
export default __webpack_public_path__ + "static/media/RentedBanner.698e6c9979ebe5bffa6959ff091c206d.svg";
export { ForwardRef as ReactComponent };